import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ProductsService } from 'src/app/services/products.service';
import { ConfigService } from 'src/app/services/config.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
export class ModalRedeemInsurancePage {
    constructor(modalController, authService, toolsService, productsService, configService, analyticsService) {
        this.modalController = modalController;
        this.authService = authService;
        this.toolsService = toolsService;
        this.productsService = productsService;
        this.configService = configService;
        this.analyticsService = analyticsService;
        /*tab group index*/
        this.tabGroupIndex = 0;
        this.insuranceQuestions1 = [];
        this.insuranceQuestions2 = [];
        this.InsurancePrice = 0;
        this.analyticsService.AnalyticsServiceModalView('redeem-insurance');
        this.loadUser();
    }
    ngOnInit() {
    }
    ionViewDidEnter() {
        this.loadForm();
    }
    //Function to load user data
    loadUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.toolsService.showLoader();
            try {
                this.user = yield this.authService.getPlayerFullData();
            }
            catch (error) {
                this.toolsService.showErrorToast();
                console.error('[modal-redeem-coupon.page] loadUser');
            }
            yield this.toolsService.dismissLoader();
        });
    }
    //Function to load address form 
    loadForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.insuranceQuestions1 = [
                { label: 'Placa', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required, Validators.pattern(/^[0-9A-Z]+$/), Validators.minLength(6)]) },
                { label: 'Número de teléfono', format: 'input', type: 'number', formControl: new FormControl('', [Validators.required, Validators.maxLength(10)]) },
                { label: 'Nombres', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required, Validators.maxLength(30), this.toolsService.specialCharactersValidator]) },
                { label: 'Apellidos', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required, Validators.maxLength(30), this.toolsService.specialCharactersValidator]) },
                { label: 'Tipo de documento', format: 'select', options: [{ name: "NIT", value: "50001" }, { name: "CC", value: "50002" }, { name: "CE", value: "50003" }], formControl: new FormControl('', [Validators.required, Validators.maxLength(30)]) },
                { label: 'Documento', format: 'input', type: 'number', formControl: new FormControl('', [Validators.required]) },
                { label: 'E-mail', format: 'input', type: 'email', formControl: new FormControl('', [Validators.required, Validators.pattern(/.*@.*\..*/)]) },
                { label: 'Dirección', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required, Validators.maxLength(60), this.toolsService.specialCharactersValidator]) }
            ];
        });
    }
    //Function to insert current user data into form
    useMyData(event) {
        if (event.checked) {
            this.insuranceQuestions1[2].formControl.setValue(this.user.user.first_name);
            this.insuranceQuestions1[3].formControl.setValue(this.user.user.last_name);
            this.insuranceQuestions1[6].formControl.setValue(this.user.user.email);
            if (this.user.document)
                this.insuranceQuestions1[5].formControl.setValue(this.user.document);
            if (this.user.cellphone)
                this.insuranceQuestions1[1].formControl.setValue(this.user.cellphone);
        }
        else {
            for (let question of this.insuranceQuestions1)
                question.formControl.setValue('');
        }
    }
    //Function to load body of the request for getting options
    /* getRequestBody(){
      var body = {
        brand_id: this.product.brand_id
      }
      return body;
    } */
    //Function to load additional body
    /* getAdditionalBody(type){
      if(type == 'get_cities')
        return [{name: 'dep_id', formControl: this.couponQuestions2[0].formControl}]
      else if(type == 'get_sites')
        return [{name: 'dep_id', formControl: this.couponQuestions2[0].formControl}, {name: 'city_id', formControl: this.couponQuestions2[1].formControl}]
    } */
    //Function to close modal
    closeModal() {
        this.modalController.dismiss();
    }
    addToShoppingCart() {
        if (this.toolsService.validateQuestions(this.insuranceQuestions2)) {
            /*var additional_info = this.insurance_quotation  {
              name: this.couponQuestions1[0].formControl.value,
              email: this.couponQuestions1[1].formControl.value,
              document: this.couponQuestions1[2].formControl.value
            } */
            let product_info = {
                product: this.product,
                additional_info: this.insurance_quotation,
            };
            this.modalController.dismiss(product_info);
        }
        else {
            this.toolsService.markAsTouched(this.insuranceQuestions2);
        }
    }
    createInsuranceQuotation() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.toolsService.validateQuestions(this.insuranceQuestions1)) {
                yield this.toolsService.showLoader();
                try {
                    this.insurance_quotation = yield this.productsService.createInsuranceQuotation(this.insuranceQuestions1);
                    let homologateOptions = [];
                    for (let homologation of this.insurance_quotation.HomologateResult) {
                        let option = { name: homologation.VehicleTypeName, value: homologation.VehicleTypeId };
                        homologateOptions.push(option);
                    }
                    this.insuranceQuestions2 = [
                        {
                            label: 'Seleccione una opción',
                            format: 'select',
                            options: homologateOptions,
                            formControl: new FormControl('', [Validators.required])
                        },
                    ];
                    if (homologateOptions.length == 1) {
                        this.insuranceQuestions2[0].formControl.setValue(homologateOptions[0].value);
                    }
                    this.insurance_quotation.StartDate = this.insurance_quotation.StartDate.substring(0, 4) + '-' + this.insurance_quotation.StartDate.substring(4, this.insurance_quotation.StartDate.length);
                    this.insurance_quotation.StartDate = this.insurance_quotation.StartDate.substring(0, 7) + '-' + this.insurance_quotation.StartDate.substring(7, this.insurance_quotation.StartDate.length);
                    this.insurance_quotation.EndDate = this.insurance_quotation.EndDate.substring(0, 4) + '-' + this.insurance_quotation.EndDate.substring(4, this.insurance_quotation.EndDate.length);
                    this.insurance_quotation.EndDate = this.insurance_quotation.EndDate.substring(0, 7) + '-' + this.insurance_quotation.EndDate.substring(7, this.insurance_quotation.EndDate.length);
                    this.tabGroupIndex = this.tabGroupIndex + 1;
                }
                catch (error) {
                    if (error.status == 400)
                        this.toolsService.showErrorToast(error.error.replace(/^[0-9]+\s-\s/, ''));
                    else
                        this.toolsService.showErrorToast();
                    console.error('[modal-redeem-insurance.page] CreateInsuranceQuotation');
                }
                yield this.toolsService.dismissLoader();
            }
            else {
                this.toolsService.markAsTouched(this.insuranceQuestions1);
            }
        });
    }
    updateInsuranceQuotation() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.toolsService.validateQuestions(this.insuranceQuestions2)) {
                if (this.insurance_quotation.HomologateResult.length > 1) {
                    yield this.toolsService.showLoader();
                    try {
                        this.insurance_quotation = yield this.productsService.updateInsuranceQuotation(this.insurance_quotation.QuotePublicId, this.insuranceQuestions2[0].formControl.value);
                        this.settingNewCustomPrice(parseInt(this.insurance_quotation.TotalValue));
                        this.tabGroupIndex = this.tabGroupIndex + 1;
                    }
                    catch (error) {
                        this.toolsService.showErrorToast();
                        console.error('[modal-redeem-coupon.page] loadUser');
                    }
                    yield this.toolsService.dismissLoader();
                }
                else {
                    this.settingNewCustomPrice(parseInt(this.insurance_quotation.TotalValue));
                    this.tabGroupIndex = this.tabGroupIndex + 1;
                }
            }
            else {
                this.toolsService.markAsTouched(this.insuranceQuestions1);
            }
        });
    }
    setTabGroupIndex(event) {
        this.tabGroupIndex = event;
    }
    displayDisc(discount_value) {
        try {
            return discount_value.indexOf('Dcto') > -1;
        }
        catch (e) {
            return false;
        }
    }
    settingNewCustomPrice(price) {
        this.InsurancePrice = price;
        this.product.price = this.configService.price_to_points(this.product, price);
        console.log(this.product);
        this.product.custom_price_cash = this.configService.price_by_company(this.product, price);
        if (this.product.discount > 0) {
            if (this.displayDisc(this.product.discount_value)) {
                var discount_percentage = this.product.discount_value.replace(/% Dcto/, "");
                this.product.discount = this.product.price * discount_percentage / 100;
            }
        }
    }
}
